export default __webpack_public_path__ + "static/media/main-bar-group-lyte@3x.e0a3e88d.png";